// Единая точка переименования продукта: все строки языкового пакета проходят через неё до
// попадания в словарь i18n, поэтому в интерфейсе не остаётся старых названий — ни из удалённого
// пакета, ни из локального overrides.
const BRAND = 'Qunixor';

const REPLACEMENTS: [RegExp, string][] = [
  // домены: наш веб живёт на web.qunixor.org, прочие telegram-поддомены ведущие на apex-заглушку
  [/web\.telegram\.org/g, 'web.qunixor.org'],
  [/[\w.-]*telegram\.org/g, 'qunixor.org'],
  // витрина NFT-юзернеймов и номеров у нас своя: в текстах про «купить на fragment.com» — наш хост
  [/fragment\.com/g, 'market.qunixor.org'],
  // ссылки t.me/… уходят на наш публичный хост: строки языкового пакета с чужим доменом
  // в интерфейсе быть не должно, а превью-карточку по такому адресу отдаёт link.qunixor.org.
  // Сначала с схемой, потом голый хост: иначе второй шаблон съест часть первого.
  [/https:\/\/t\.me\//g, 'https://link.qunixor.org/'],
  [/telegram\.me\//g, 'link.qunixor.org/'],
  [/(^|[^.\w-])t\.me\//g, '$1link.qunixor.org/'],
  // затем сам бренд: сначала слитные написания, потом одиночное слово в трёх регистрах
  [/mytelegram/g, BRAND.toLowerCase()],
  [/MyTelegram/g, BRAND],
  [/MYTELEGRAM/g, BRAND.toUpperCase()],
  [/\bTelegram\b/g, BRAND],
  [/\btelegram\b/g, BRAND.toLowerCase()],
  [/\bTELEGRAM\b/g, BRAND.toUpperCase()]
];

export function rebrandName<T>(value: T): T {
  if(typeof value === 'string') {
    return REPLACEMENTS.reduce((acc: string, [pattern, replacement]) => acc.replace(pattern, replacement), value) as unknown as T;
  }

  if(Array.isArray(value)) {
    return value.map((item) => rebrandName(item)) as unknown as T;
  }

  if(value && typeof value === 'object') {
    for(const key of Object.keys(value)) {
      (value as Record<string, any>)[key] = rebrandName((value as Record<string, any>)[key]);
    }
  }

  return value;
}

export default rebrandName;
